import { circleStyle } from './MapVectorStyles.js';
import Feature from 'ol/Feature';
import Point from 'ol/geom/Point';

const CircleFeature = (props) => {
    const { x, y, val, size, color, info, textColor = '#000', offset, data } = props;

    const cirFeat = new Feature({
        geometry: new Point([x, y]),
        poi: true,
        info,
        count: val,
        data
    });
    cirFeat.setStyle(circleStyle(val, size, color, textColor, offset));
    return cirFeat;
};

export default CircleFeature;

const bubbleZoomSizeMatrix = {
    2: {
        subdivide: 100,
        pixelRange: [30, 40],
        valueScaling: [300, 3000]
    },
    3: {
        subdivide: 100,
        pixelRange: [30, 40],
        valueScaling: [100, 3000]
    },
    4: {
        subdivide: 100,
        pixelRange: [30, 40],
        valueScaling: [100, 1000]
    },
    5: {
        subdivide: 100,
        pixelRange: [30, 40],
        valueScaling: [100, 1000]
    },
    6: {
        subdivide: 50,
        pixelRange: [30, 50],
        valueScaling: [50, 800]
    },
    7: {
        subdivide: 50,
        pixelRange: [30, 50],
        valueScaling: [5, 300]
    },
    8: {
        subdivide: 10,
        pixelRange: [30, 70],
        valueScaling: [1, 150]
    },
    9: {
        subdivide: 10,
        pixelRange: [30, 70],
        valueScaling: [1, 100]
    },
    10: {
        subdivide: 1,
        pixelRange: [30, 70],
        valueScaling: [1, 50]
    },
    11: {
        subdivide: 1,
        pixelRange: [30, 70],
        valueScaling: [1, 30]
    },
    12: {
        subdivide: 1,
        pixelRange: [40, 70],
        valueScaling: [1, 10]
    },
    13: {
        subdivide: 1,
        pixelRange: [40, 70],
        valueScaling: [1, 10]
    },
    14: {
        subdivide: 1,
        pixelRange: [40, 70],
        valueScaling: [1, 10]
    },
    15: {
        subdivide: 1,
        pixelRange: [40, 70],
        valueScaling: [1, 10]
    }
};
export { bubbleZoomSizeMatrix };

const PoiBubble = (props) => {
    const { x, y, data, poiInfo, map } = props;
    const { color, textColor } = poiInfo;
    const zoom = Math.floor(map.getView().getZoom());
    const size = calculateBubbleSize(data.length, zoom);

    return CircleFeature({
        x,
        y,
        color,
        textColor,
        val: data.length,
        size,
        info: poiInfo,
        data
    });
};

export { PoiBubble };

const convertRange = (value, r1, r2) => ((value - r1[0]) * (r2[1] - r2[0])) / (r1[1] - r1[0]) + r2[0];
export { convertRange };

const calculateBubbleSize = (val, zoom) => {
    const bubbleLimits = bubbleZoomSizeMatrix[zoom];
    const minimumValueScale = bubbleLimits.valueScaling[0];
    const maximumValueScale = bubbleLimits.valueScaling[1];
    let valWithinRange;
    valWithinRange = Math.max(val, minimumValueScale);
    valWithinRange = Math.min(val, maximumValueScale);
    return Math.ceil(convertRange(valWithinRange, bubbleLimits.valueScaling, bubbleLimits.pixelRange)); //* 1.75;
};
